import React from "react";
import { LinkedInCallback } from "react-linkedin-login-oauth2";

/**
 * OAuth popup callback — same as RP (/linkedin → LinkedInCallback).
 * Must match REACT_APP_LINKEDIN_REDIRECT_URL and LinkedIn app redirect URLs.
 */
export default function LinkedInCallbackPage() {
  return <LinkedInCallback />;
}
